export default function About() {
  return (
    <section id="about" className="relative py-32 px-8 bg-gradient-to-b from-black via-amber-950/10 to-black">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="inline-block px-4 py-2 border border-amber-500/50 rounded-sm">
              <span className="text-amber-400/80 text-xs tracking-[0.4em] font-light uppercase" style={{ fontFamily: "'Noto Sans TC', sans-serif" }}>ABOUT ME</span>
            </div>

            <h2 className="text-6xl font-bold leading-tight" style={{ fontFamily: "'Noto Serif TC', serif" }}>
              <div className="text-white drop-shadow-[0_0_20px_rgba(255,255,255,0.2)]">
                打造電影感的
              </div>
              <div
                style={{
                  fontFamily: "'Noto Serif TC', serif",
                  background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 40%, #fde68a 70%, #d97706 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  filter: 'drop-shadow(0 0 20px rgba(251,191,36,0.4))',
                }}
              >
                品牌視覺敘事 ✦
              </div>
            </h2>

            <p className="text-white/85 text-lg leading-relaxed" style={{ fontFamily: "'Noto Sans TC', sans-serif" }}>
              我是Adam Chen，一位專注於AI影視製作的工作者。結合最先進的人工智慧技術與傳統影視美學，為品牌打造獨一無二的視覺故事。從概念發想到後期製作，每一個細節都經過精心雕琢，創造出令人驚艷的電影感視覺體驗。
            </p>

            <p className="text-white/70 text-base leading-relaxed" style={{ fontFamily: "'Noto Sans TC', sans-serif" }}>
              專精於AI場景生成、動態特效設計、3D動畫製作以及數位藝術創作。致力於探索AI技術在影視創作中的無限可能，將科技與藝術完美融合，為每一個專案注入獨特的突圍元素。
            </p>

            <a
              href="#contact"
              className="inline-block text-amber-400 hover:text-amber-300 transition-colors duration-300 border-b border-amber-400/60 hover:border-amber-300 pb-1 cursor-pointer text-sm tracking-widest"
              style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
            >
              取得報價 →
            </a>
          </div>

          <div className="relative">
            <div className="relative z-10 grid grid-cols-2 gap-6">
              <div className="col-span-1 mt-12">
                <div className="relative rounded-lg overflow-hidden border border-amber-500/40 shadow-2xl shadow-amber-500/20 hover:shadow-amber-500/40 transition-all duration-300 hover:scale-105 aspect-square">
                  <img
                    src="https://public.readdy.ai/ai/img_res/22c6f127d45250b993a1bb982116441e.jpg"
                    alt="工作照片"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="col-span-1">
                <div className="relative rounded-lg overflow-hidden border border-amber-400/30 shadow-2xl shadow-amber-400/20 hover:shadow-amber-400/40 transition-all duration-300 hover:scale-105 aspect-[3/4]">
                  <img
                    src="https://static.readdy.ai/image/a3593b145406fb9c6931679884b63fd0/07e510b2d83f32d6c7f8ed1db84c1a68.jpeg"
                    alt="創作過程"
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                </div>
              </div>
            </div>
            {/* Decorative glow */}
            <div className="absolute -inset-4 bg-amber-500/5 rounded-2xl blur-2xl pointer-events-none" />
          </div>
        </div>
      </div>
    </section>
  );
}
